@if (!isAuthenticated()) {
  <div class="flex h-screen items-center justify-center bg-white">
    <dome-spinner/>
  </div>
} @else {
  <div class="flex h-screen flex-col overflow-hidden">
    <div class="flex flex-1 overflow-hidden">
      <main
        class="flex-1 overflow-auto shadow-inner transition-all duration-300"
      >
        <router-outlet/>
      </main>
    </div>
  </div>
}
